import { useEffect, useState } from "react";
import { putRAGSettings } from "../../service";
import { message } from "antd";
import { Button } from "V2.0/common/button";
import { Switch } from "V2.0/common/switch";

export function CRMSearchEnabled(props) {
  const { ragSettings, workspaceId, assistantId, syncAssistant, locked } =
    props;
  const [crmSearchEnabled, setCrmSearchEnabled] = useState(
    ragSettings?.crmSearchEnabled
  );

  const handleSave = async (updatedState) => {
    message.loading("Saving");
    const payload = {
      crmSearchEnabled: updatedState,
    };
    try {
      const response = await putRAGSettings({
        workspaceId,
        assistantId,
        payload,
      });
      if (response.status === 200) {
        message.destroy();
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            ragSettings: response.data,
          };
        });
        message.success("Settings saved");
      }
    } catch (e) {
      setCrmSearchEnabled((prevState) => !prevState);
      message.destroy();
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to save settings"
      );
    }
  };

  function updateCrmSearchEnabled() {
    const updatedState = !crmSearchEnabled;

    setCrmSearchEnabled(updatedState);
    handleSave(updatedState);
  }

  return (
    <div className="flex flex-col w-3/5 min-w-[600px] border rounded-lg m-4">
      <div className="px-6 py-4 bg-gray-50 space-y-2 rounded-lg">
        <div className="flex justify-between">
          <p className="text-base font-semibold">Search Contacts</p>
          <Switch
            color="emerald"
            onChange={() => {
              updateCrmSearchEnabled();
            }}
            checked={crmSearchEnabled}
            disabled={locked}
          />
        </div>
        <p className="text-sm text-gray-500">
          Allow to search CRM to get the first name of the User
        </p>
      </div>
    </div>
  );
}
